export const FILE_DOWNLOAD_POLL_INTERVAL = 350
